export enum actionTypes {
  NIVELES_LABORALES_FETCH = 'NIVELES_LABORALES_FETCH',
  NIVELES_LABORALES_SUCCESS = 'NIVELES_LABORALES_SUCCESS',
  NIVELES_LABORALES_ERROR = 'NIVELES_LABORALES_ERROR',
  NIVELES_LABORALES_RESET = 'NIVELES_LABORALES_RESET',
}

export enum NivelesLaboralesStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface NivelesLaborales {
  id: number
  nombre: string
}

export interface NivelesLaboralesState {
  status: NivelesLaboralesStatus
  nivelesLaborales: Array<NivelesLaborales>
}

export interface NivelesLaboralesFetch {
  type: typeof actionTypes.NIVELES_LABORALES_FETCH
}

export interface NivelesLaboralesSuccess {
  type: typeof actionTypes.NIVELES_LABORALES_SUCCESS
  payload: { nivelesLaborales }
}

export interface NivelesLaboralesError {
  type: typeof actionTypes.NIVELES_LABORALES_ERROR
  payload: null
}

export interface NivelesLaboralesReset {
  type: typeof actionTypes.NIVELES_LABORALES_RESET
  payload: null
}

export type NivelesLaboralesActions =
  | NivelesLaboralesFetch
  | NivelesLaboralesSuccess
  | NivelesLaboralesError
  | NivelesLaboralesReset

export const initialState: NivelesLaboralesState = {
  status: NivelesLaboralesStatus.Idle,
  nivelesLaborales: [],
}
